export default __webpack_public_path__ + "static/media/reset15.a2f06117.png";